import { formatManilaDateTime } from "../../../utils/manilaTime";
import { cx } from "../../../utils/classNames";
import { ACTIVITY_LABELS } from "../performanceUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

const ActivityTimeline = ({ activities = [] }) => {
  if (!activities.length) return null;

  return (
    <div className={cx(ui.card, ui.cardPadded)}>
      <div className={cx(ui.cardTitle, "mb-2")}>Timeline</div>
      <ul className={styles.timeline}>
        {activities.map((activity) => (
          <li key={activity.id}>
            <span className={styles.timelineDot} />
            <div>
              <div>
                <strong>
                  {ACTIVITY_LABELS[activity.action] ?? activity.action}
                </strong>
                {activity.stepLabel && ` · ${activity.stepLabel}`}
              </div>
              <div className={ui.muted}>
                {formatManilaDateTime(activity.createdAt)}
              </div>
              {activity.remarks && <div>“{activity.remarks}”</div>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ActivityTimeline;
